export default "__VITE_ASSET__b87db9ca__"